<template>
  <div
    id="app"
    @touchmove.prevent=""
  >
    <!-- loading页 -->
    <Pages v-show="!prompt" />

    <!-- 提示竖屏锁定 -->
    <Prompt v-show="prompt" />

  </div>
</template>

<script>
// pages
import Pages from "./pages";
// 提示竖屏锁定
import Prompt from "./pages/prompt";

import { mapActions } from "vuex";
import { HS, device, remJs } from "./tools";
export default {
  name: "app",
  components: {
    Pages,
    Prompt
  },
  computed: {
    prompt() {
      return this.$store.state.prompt;
    },
    videoObj() {
      return this.$store.state.videoObj;
    },
    audioObj() {
      return this.$store.state.audioObj;
    },
    resVideoObj() {
      return this.$store.state.resVideoObj;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  created() {
    let dev = device();
    if (dev !== "iPad" && dev !== "iPod" && dev !== "Pc") {
      // mobile
      this.promptShow();
      this.init(true, 750); // 修改全局设备标记 dev 为true（mobile）
    } else if (dev === "iPad" || dev === "iPod") {
      // ipad
      this.init(true, 1024);
      this.promptShow();
    } else {
      // pc
      this.init(false, 1920); // 修改全局设备标记 dev 为false（pc）
    }
  },
  methods: {
    ...mapActions(["promptFn", "devFn"]),
    init(boolean, rem) {
      this.devFn(boolean); // 修改全局设备标记 dev 为true（mobile）
      remJs(rem);
    },
    promptShow() {
      HS(t => {
        if (t) {
          this.promptFn(true); // 显示
          this.mediaPause(); // 暂停
        } else {
          this.promptFn(false); // 隐藏
          this.mediaPlay(); // 播放
        }
      });
    },
    // videoObj: null, // 视频对象
    // audioObj: null, // 因屏对象
    // resVideoObj: null, // 第二个视频对象
    mediaPause() {
      if (this.videoObj) {
        this.videoObj.muted = true;
      }
      if (this.resVideoObj) {
        this.resVideoObj.muted = true;
      }
      if (this.audioObj) {
        this.audioObj.pause();
      }
    },
    mediaPlay() {
      if (this.videoObj) {
        this.videoObj.muted = false;
      }
      if (this.resVideoObj) {
        this.resVideoObj.muted = false;
      }
      if (!this.loading) {
        this.audioObj.play();
        // if (this.audioObj && this.videoObj.paused && this.resVideoObj.paused) {
        //   this.audioObj.play();
        // }
      }
    }
  }
};
</script>

<style>
#app {
  height: 100%;
  width: 100%;
}
</style>
